import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";
import SearchBar from "../../components/SearchBar";
import TableComponent from "../../components/TableComponent";

const ManageLeaves = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");

  const rows = [
    {
      id: 1,
      visaType: "Tourist",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Company",
    },
    {
      id: 2,
      visaType: "Study",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Freelancer Agent",
    },
    {
      id: 3,
      visaType: "Work",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Salaried Agent",
    },
    {
      id: 4,
      visaType: "Business",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Self Registration",
    },
    {
      id: 5,
      visaType: "Business",
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
      country: "Canada",
      nationality: "Indian",
      registeredBy: "Self Registration",
    },
  ];

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.03,
      minWidth: 80,
      field: "id",
      headerName: "S.No",
      editable: false,
      sortable: false,
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: "name",
      headerName: "Agent Details",
      editable: false,
      sortable: false,

      renderCell: () => {
        return (
          <div className="user_block">
            <figure onClick={() => navigate("/profile-detail/salaried-agent")}>
              <img src="/static/images/user_attachment.jpg" alt="" />
            </figure>
            <p>
              <b>Emma Smith</b> +9203024595467 <br />
              emma@gmail.com
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "leaveType",
      headerName: "Leave Type",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <p>Full Day</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "from",
      headerName: "From",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <p>22 Aug 2024</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "to",
      headerName: "To",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <p>23 Aug 2024</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "reason",
      headerName: "Reason",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="user_block">
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleClose1}>Approve</MenuItem>
                <MenuItem onClick={handleClose1}>Reject</MenuItem>

                <MenuItem onClick={() => navigate(`detail/${1}`)}>
                  View
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Leaves</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Leaves
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search"
                />
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent columns={columns} rows={rows} />
          </div>
        </Box>
      </div>
    </MainContainer>
  );
};

export default ManageLeaves;
